import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Card,
  CardContent,
  CardActions,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,Container,Grid,Box
} from "@material-ui/core";
import AppointmentHistoryCardView from "./AppointmentHistoryCardView";
import AppointmentListCalendarView from './AppointmentListCalendarView';



const AppointmentHistoryList = (props) => {
  const appointmentList = props.appointmentList;
  const isCalenderView = props.isCalenderView;
  const handleCancelAppointment = props.handleCancelAppointment;
  const handleEditAppointment = props.handleEditAppointment;
  const showSingleGrid = props.showSingleGrid;
  const showEditAppointment = props.showEditAppointment;
  return(
    <>
      
          {
            isCalenderView? <AppointmentListCalendarView appointmentList={appointmentList}/> :
            appointmentList.length>0?
          <Grid
            container
            spacing={1}
            style={{marginTop: 30 }}
          >
            {appointmentList.map((appointment) => (
              
              <Grid
              style={{
                width : '100%',
              }}
                item
                key={appointment.id}
                md={showSingleGrid?12:6}
                sm={12}
              >
                <AppointmentHistoryCardView appointment={appointment}
                handleEditAppointment ={handleEditAppointment}
                handleCancelAppointment={handleCancelAppointment}
                showEditAppointment={showEditAppointment}
                handleConfirmAppointment ={props.handleConfirmAppointment}
                />
              </Grid>
            ))}
          </Grid>:
          <Typography variant="h4" color="inherit">No appointment history</Typography>
          }
        </>
  )
};

AppointmentHistoryList.propTypes = {
  isCalenderView: PropTypes.bool.isRequired,
  appointmentList : PropTypes.array.isRequired
};

export default AppointmentHistoryList;
